import { IForm } from 'core-components/classes/models/IForm'
import { DateHelper } from 'onboarding/utils/dateHelper'

import { ICaseOwnerSetDateInfo } from '../../classes/models/ICaseOwnerSetDateInfo'

export const mapCaseOwnerSetDateInfo = (data: IForm): ICaseOwnerSetDateInfo => ({
  entryId: data.EntryId,
  field: data.Field,
  requestId: data.RequestId,
  value: DateHelper.convertServerISOToDate(data.Value),
})
